export default __webpack_public_path__ + "static/media/momo04.4be2247f.png";